import { useMutation } from '@tanstack/react-query';
import { apiClient, queryClient } from '@common/http/query-client';
import { BackendResponse } from '@common/http/backend-response/backend-response';
import { toast } from '@common/ui/toast/toast';
import { message } from '@common/i18n/message';
import { showHttpErrorToast } from '@common/utils/http/show-http-error-toast';
import { DatatableDataQueryKey } from '@common/datatable/requests/paginated-resources';
import { FileItem } from '@app_modules/loan-applications/step1/file-item';

interface Response extends BackendResponse {}

interface Payload {
  id: number | string;
  loan_program_type: string;
  investor_code: string;
  sheet_name: string;
}

export function useRemoveAnalyzeSubItemRateSheet(id: number | string, loan_program_type: string, investor_code: string, sheet_name: string) {
  return useMutation({
    mutationFn: (payload: Payload) =>
      removeAnalyzeSubItemRateSheet(payload), // Fixed typo and adjusted to accept payload
    onSuccess: (response: any, payload) => {
      if (response.message) {
        toast(message(response.message));
      } else {
        toast(message(`You have just removed investor code ${payload.investor_code}.`));
      }
      queryClient.invalidateQueries({ queryKey: DatatableDataQueryKey(`check-points/${payload.id}`) }); // Uncommented and adjusted
    },
    onError: (err) => {
      console.error('Mutation error:', err); // Log error details for debugging
      showHttpErrorToast(err);
    },
  });
}

function removeAnalyzeSubItemRateSheet({
  id,
  loan_program_type,
  investor_code,
  sheet_name,
}: Payload): Promise<Response> {
  return apiClient
    .post(`market-rates/${id}/remove-analyze-sub-item`, {
      loan_program_type,
      investor_code,
      sheet_name,
    })
    .then((r) => r.data);
}